export const FEEDBACK_MODEL_KEY = {

  ID: 'id',
  CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',

  MESSAGE: 'message',
  REPLIES: 'replies',
  STATUS: 'status',
  TYPE: 'type',
  READ_AT: 'readAt',
  SENDER_READ_AT: 'senderReadAt',

  ATTACHMENT_ID: 'attachmentId',
  ATTACHMENT_CLASS_NAME: 'attachmentClassName',

  // Associations
  PROFILE_ID: 'profileId',

  // Virtual associations
  PROFILE: 'profile',
  USER: 'user'

}

export const FEEDBACK_MODEL_PRIVATE_KEYS = []

export const FEEDBACK_MODEL_CLASS_NAME = 'Feedback'

export const FEEDBACK_MODEL_AUDIT = {
  CREATED: 'Feedback Created',
  UPDATED: 'Feedback Updated',
  DELETED: 'Feedback Deleted'
}

export const FEEDBACK_MODEL_SCOPE = {

  /**
   * Only returns the public attributes of the Post.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: FEEDBACK_MODEL_PRIVATE_KEYS
    }
  }

}

export const FEEDBACK_MODEL_STATUS = {

  // General
  OPEN: 1,
  IN_PROGRESS: 2,
  CLOSED: 3

}

export const FEEDBACK_MODEL_TYPE = {

  // General
  BUG: 1,
  QUESTION: 2,
  GENERAL_FEEDBACK: 3,

  // Exercises
  EXERCISE_ADD: 1000,
  EXERCISE_QUESTION: 1001,

  // Workouts
  WORKOUTS_ADD: 2000,
  WORKOUTS_QUESTION: 2001

}
